<script setup lang="ts">
import FormField from "@/components/common/FormField.vue3.vue"
import { SignatureDocumentFieldType } from '@/store/enums';
import {computed, onMounted, Ref, ref} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";

const props = defineProps<{
    documentIndex: number,
    fieldIndex: number
}>();

const emit = defineEmits<{ (e: 'update'): void }>();
const value = ref('');

const intakeStore = usePortalIntakeStore();
const validationState = computed(() => intakeStore.getters.getSignatureFieldValidationState({ docIndex: props.documentIndex, fieldIndex: props.fieldIndex }));
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) => 
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Comments, value})
);
</script>

<template>
    <div>
        <form-field :validation-state="validationState">
            <p-text-area
                v-model="value"
                :class="[validationState?.invalid && 'field-validation-error', 'w-full']"
                auto-resize
                rows="3"
                maxlength="1000"
                placeholder="Enter comments here..."
                @input="emit('update')"
            />
        </form-field>
        <span class="signature-form-data signature-form-comments">
            {{ value }}
        </span>
    </div>
</template>

<style scoped lang="scss">
.validation-error {
    background-color: #ffbdbd;
}
</style>